module.exports = __webpack_public_path__ + "img/map-badge.47bb8733.svg";